var modulePageBooking = function() {
  var $ = jQuery;
  var _this;

  var module = {
    init: function() {
      _this = this;
      this.modifyDOM();
      this.addEvents();
      _this.helpers.checkURLParams();
    },

    workshopHours: window.wp_workshop_hours,

    isFetchingCarInfo: false,

    picker: {},

    pickerOpts: {
      field: $('#datepicker')[0],
      format: 'YYYY-MM-DD',
      bound: false,
      firstDay: 1,
      minDate: new Date(),
      i18n: {
        previousMonth: 'Föregående månad',
        nextMonth: 'Nästa månad',
        months: window.moment.localeData()._months,
        weekdays: window.moment.localeData()._weekdays,
        weekdaysShort: window.moment.localeData()._weekdaysShort
      }
    },

    values: {
      regnr: '',
      manualBrand: '',
      certService: '',
      workshop: '',
      date: '',
      time: '',
      services: '',
      message: '',
      name: '',
      phone: '',
      email: '',
      odometer: '',
      rentalCar: '',
      wishToWait: false,
      discountCode: ''
    },

    modifyDOM: function() {
      _this.helpers.setupDatepicker();
      $('[name="rental-car"]').prop('checked', true).trigger('change');
      $('[name="message"]').autogrow();
    },

    addEvents: function() {
      $('body').on('keyup', '[name=regnr]',         _this.eventHandlers.regnrChanged).
                on('change', '#datepicker',         _this.eventHandlers.dateChanged).
                on('change', '[name=time]',         _this.eventHandlers.timeChanged).
                on('change', '[name=services]',     _this.eventHandlers.servicesChanged).
                on('change keydown', '[name=message]',      _this.eventHandlers.messageChanged).
                on('change keydown', '[name=discount_code]',      _this.eventHandlers.discountCodeChanged).
                on('change', '[name=name]',         _this.eventHandlers.nameChanged).
                on('change', '[name=phone]',        _this.eventHandlers.phoneChanged).
                on('change', '[name=email]',        _this.eventHandlers.emailChanged).
                on('change', '[name=odometer]',     _this.eventHandlers.odometerChanged).
                on('change', '[name=rental-car]',   _this.eventHandlers.rentalCarChanged).
                on('change', '[name=wish-to-wait]', _this.eventHandlers.wishToWaitChanged).
                on('change', '[name=manual-brand]', _this.eventHandlers.manualBrandChanged).
                on('change', '[name=workshop]',     _this.eventHandlers.workshopChanged).
                on('change keydown', '[name=regnr], [name=name], [name=phone], [name=email], [name=odometer], [name=services], [name=message]', _this.eventHandlers.requiredFieldChanged).
                on('submit', 'form',                _this.eventHandlers.onSubmit);
    },

    eventHandlers: {
      workshopChanged: function() {
        _this.values.workshop = $('[name=workshop]:checked').val();
        $('[name=workshop]').each(function() {
          if($(this).attr('value') == _this.values.workshop) {
            $(this).parent().addClass('selected');
          } else {
            $(this).parent().removeClass('selected');
          }
        });
        _this.helpers.enableFormGroup('calendar');
        _this.helpers.updateDatepicker();
        _this.helpers.updateServices();
      },

      manualBrandChanged: function() {
        var $selectedWorkshop;

        $('.workshop-selector').addClass('hide');

        // if selected service is certified..
        if ($('.workshop-selector#cert-' + this.value).length) {
          _this.values.certService = this.value;
          _this.values.manualBrand = '';
          $selectedWorkshop = $('.workshop-selector#cert-' + this.value);
          var primary = $selectedWorkshop.data('primary-color');
          var secondary = $selectedWorkshop.data('secondary-color');
          _this.helpers.setCalendarStyling(primary, secondary);
        } else {
          _this.values.certService = '';
          _this.values.manualBrand = this.value;
          $('.car-brand-name').text(this.value || 'din bil');
          $selectedWorkshop = $('.workshop-selector#uncertified');
          _this.helpers.setCalendarStyling();
        }

        $selectedWorkshop.removeClass('hide');
        $selectedWorkshop.find('[name=workshop]:first-of-type').first().prop('checked', true).trigger('change');
        _this.values.workshop = $('[name=workshop]:checked').val();
        $(document).trigger('reInitGmaps');
      },

      requiredFieldChanged: function() {
        if (_this.values.regnr && _this.values.name && _this.values.phone && _this.values.email && _this.values.odometer && (_this.values.message || _this.values.services)) {
          $('[type=submit]').prop('disabled', false);
          $('.validation-error--form').removeClass('active');
        } else {
          $('[type=submit]').prop('disabled', true);
          $('.validation-error--form').addClass('active');
        }

        if (!_this.values.regnr) {
          $('.validation-error--regnr').addClass('active');
        } else {
          $('.validation-error--regnr').removeClass('active');
        }
      },

      onSubmit: function() {
        console.log(_this.values);

        $('[type=submit]').addClass('btn--spinner--spinning');
        $('[type=submit]').prop('disabled', true);

        $.post('/wp/wp-admin/admin-ajax.php', {
          action: 'post_booking',
          values: _this.values
        }).success(function() {
          window.location.href = $('[type=submit]').data('thanks-url') +
                                  '?selectedWorkshop=' + _this.values.workshop +
                                  '&selectedCertService=' + _this.values.certService +
                                  '&selectedServices=' + _this.values.services;
        }).fail(function() {
          $('[type=submit]').removeClass('btn--spinner--spinning');
          $('[type=submit]').prop('disabled', false);
          $('.submit-fail').removeClass('hide');
        });

        return false;
      },

      regnrChanged: function() {
        if (_this.helpers.validateRegnr(this.value)) {
          _this.values.regnr = this.value;
          _this.helpers.fetchCarInfo(this.value);
        } else {
          _this.values.regnr = '';
        }
      },

      dateChanged: function() {
        _this.values.date = moment(new Date(_this.picker.getDate())).format('YYYY-MM-DD');
        // _this.helpers.updateTimepicker();
        _this.helpers.enableFormGroup('services');
      },

      timeChanged: function() {
        _this.values.time = this.value;
      },

      servicesChanged: function() {
        _this.values.services = $('[name=services]:checked').map(function() { return this.value; }).get().join(',');

        if (this.checked) {
          $('#service-warning-' + this.value).removeClass('hide');
        } else {
          $('#service-warning-' + this.value).addClass('hide');
        }

        _this.helpers.enableFormGroup('contact');
      },

      messageChanged: function() {
        _this.values.message = this.value;
        _this.helpers.enableFormGroup('contact');
      },

      discountCodeChanged: function() {
        _this.values.discountCode = this.value;
      },

      nameChanged: function() {
        if (_this.helpers.validateRequired(this.value)) {
          _this.values.name = this.value;
          $('.validation-error--name').removeClass('active');
        } else {
          _this.values.name = '';
          $('.validation-error--name').addClass('active');
        }
      },

      phoneChanged: function() {
        if (_this.helpers.validatePhone(this.value)) {
          _this.values.phone = this.value;
          $('.validation-error--phone').removeClass('active');
        } else {
          _this.values.phone = '';
          $('.validation-error--phone').addClass('active');
        }
      },

      emailChanged: function() {
        if (_this.helpers.validateEmail(this.value)) {
          _this.values.email = this.value;
          $('.validation-error--email').removeClass('active');
        } else {
          _this.values.email = '';
          $('.validation-error--email').addClass('active');
        }
      },

      odometerChanged: function() {
        if (_this.helpers.validateRequired(this.value)) {
          _this.values.odometer = this.value;
          $('.validation-error--odometer').removeClass('active');
        } else {
          _this.values.odometer = '';
          $('.validation-error--odometer').addClass('active');
        }
      },

      rentalCarChanged: function() {
        _this.values.rentalCar = $('[name=rental-car]:checked').val();
      },

      wishToWaitChanged: function() {
        _this.values.wishToWait = $(this).is(':checked') ? true : false;

        if (_this.values.wishToWait) {
          $('.js-wish-to-wait-warn').removeClass('hide');
        } else {
          $('.js-wish-to-wait-warn').addClass('hide');
        }
      }
    },

    helpers: {
      setCalendarStyling: function(primary, secondary) {
        if (!primary || !secondary) {
          primary = '#ce1b25'; // $brand-primary
          secondary = '#a51d21'; // $brand-primary-darken
        }

        /*jshint multistr: true */
        var style = '\
          .pika-single table button { background-color: ' + primary + '; } \
          .pika-single table .pika-button { background-color: ' + primary + '; } \
          .pika-single table button:hover { border-color: ' + secondary + '; } \
          .pika-single table .pika-button:hover { border-color: ' + secondary + '; } \
          .pika-single .is-selected button { border-color: ' + secondary + '; } \
          .pika-single .is-selected .pika-button { border-color: ' + secondary + '; } \
          .pika-single table button:hover { background-color: ' + secondary + '; } \
        ';

        // .pika-single table .is-today .pika-button { background-color: ' + secondary + '; } \
        // .pika-single table .pika-button:hover { background-color: ' + secondary + '; } \

        $('<style type="text/css">'+ style +'</style>').appendTo(document.head);
      },

      fetchCarInfo: function(regnr) {
        $('[name="regnr"]').prop('disabled', true);
        $('.js-regnr-spinner').spin({ lines: 7, length: 4, width: 3, radius: 5 });

        if (_this.isFetchingCarInfo) {
          return;
        }

        _this.isFetchingCarInfo = true;

        $.get('/wp/wp-admin/admin-ajax.php', {
          action: 'get_car_info',
          regnr: regnr
        }).then(function(res) {
          _this.isFetchingCarInfo = false;
          res = JSON.parse(res);
          $('[name="regnr"]').prop('disabled', false);
          $('.js-regnr-spinner').spin(false);
          _this.helpers.renderCarInfo(res);
        });
      },

      renderCarInfo: function(carInfo) {
        console.log(carInfo);

        $('.js-car-color, .js-car-model').empty();
        $('.chosen-car').addClass('hide');

        if (carInfo.not_found) {
          $('[name=manual-brand]').closest('.select--default').show();
          $('[name=manual-brand]').val('').trigger('change');
        } else {
          $('[name=manual-brand]').closest('.select--default').hide();

          if ($('[name=manual-brand]').val() !== carInfo.brand) {
            $('[name=manual-brand]').val(carInfo.brand).trigger('change');
          }

          if (carInfo.color && carInfo.model) {
            $('.chosen-car').removeClass('hide');
            $('.js-car-color').text(carInfo.color);
            $('.js-car-model').text(carInfo.model);
          }
        }
      },

      checkURLParams: function() {
        var regnr = _this.helpers.getParameterByName('regnr');
        var manualBrand = _this.helpers.getParameterByName('manualBrand');

        if (regnr) {
          $('[name=regnr]').val(regnr).trigger('keyup');
        } else if (manualBrand) {
          $('[name=manual-brand]').val(manualBrand).trigger('change');
        }
      },

      validateRequired: function(input) {
        return input.length > 0;
      },

      validateRegnr: function(input) {
        return input.match(/^[a-zA-Z]{3}\d{3}$/) || input.match(/^[a-zA-Z]{3}\d{2}[a-zA-Z]{1}$/);
      },

      validateEmail: function(input) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(input);
      },

      validatePhone: function(input) {
        var re = /^[+#*\(\)\[\]]*([0-9][ ext+-pw#*\(\)\[\]]*){6,45}$/;
        return re.test(input);
      },

      getParameterByName: function(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      },

      enableFormGroup: function(formGroup) {
        $('.form__group.js-form-group-' + formGroup).removeClass('form__group--disabled');
      },

      getWorkshopHoursById: function(id) {
        var found;

        _this.workshopHours.forEach(function(w) {
          if (w.id === parseInt(id)) {
            found = w;
            return;
          }
        });

        return found;
      },

      getWorkshopMinDate: function() {
        var daysAhead = _this.helpers.getWorkshopHoursById(_this.values.workshop).days_ahead;
        var daysAheadCalculated = 0;
        var today = moment(new Date()).toDate();

        if (!daysAhead) {
          return today;
        }

        var currentDay = today;
        var workshopMinDate;
        var triedDays = 0;

        while (daysAheadCalculated < daysAhead) {
          currentDay = moment(currentDay).add(1, 'day').toDate();

          // fix if workshop has no open days at all
          if (++triedDays > 50) {
            return today;
          }

          if (this.dayIsOpen(currentDay)) {
            workshopMinDate = moment(currentDay).add(1, 'day').toDate();
            daysAheadCalculated += 1;
          }
        }

        return workshopMinDate;
      },

      dayIsOpen: function(date) {
        return !!this.getDayHoursByDate(date).opens;
      },

      getDayHoursByDate: function(date) {
        var workshopHours = _this.helpers.getWorkshopHoursById(_this.values.workshop);
        var opens = '';
        var closes = '';

        // First look for a deviation
        workshopHours.deviations.forEach(function(d) {
          if (d.date === date) {
            opens = d.opens;
            closes = d.closes;
            return;
          }
        });

        // Or get the default for this day
        if (!opens || !closes) {
          var dayOfWeek = moment(new Date(date)).locale('en').format('dddd').toLowerCase();
          var foundDay = workshopHours.hours[dayOfWeek];
          opens = foundDay.opens;
          closes = foundDay.closes;
        }

        return {
          opens: opens,
          closes: closes
        };
      },

      updateTimepicker: function() {
        var $el = $('[name=time]');
        var hours = _this.helpers.getDayHoursByDate(_this.values.date);
        var currentHour = parseInt(hours.opens.substr(0, 2));
        var lastHour = parseInt(hours.closes.substr(0, 2));
        $el.empty();

        while (currentHour < lastHour) {
          var fHour = currentHour + ':00';

          if (currentHour < 10) {
            fHour = '0' + fHour;
          }

          $el.append('<option>' + fHour + '</option>');
          currentHour += 1;
        }
      },

      updateServices: function() {
        // uncheck prev selected
        $('.workshop-service input:checked').click().trigger('change');
        $('.workshop-service').addClass('hide');
        $('#workshop-service-' + _this.values.workshop).removeClass('hide');
      },

      updateDatepicker: function() {
        _this.picker.destroy();

        var minDate = _this.helpers.getWorkshopMinDate();

        _this.picker = new Pikaday($.extend(_this.pickerOpts, {
          minDate: minDate,
          defaultDate: minDate,
          disableDayFn: function(date) {
            var hours = _this.helpers.getWorkshopHoursById(_this.values.workshop);
            var dateIsClosed = false;
            var day = date.getDay();
            var dayStr = moment(date).locale('en').format('dddd').toLowerCase();

            if (hours.hours[dayStr].closed) {
              dateIsClosed = true;
            }

            hours.deviations_closed_days.forEach(function(h) {
              if (h === moment(date).format('YYYY-MM-DD')) {
                dateIsClosed = true;
              }
            });

            hours.deviations_open_days.forEach(function(h) {
              if (h === moment(date).format('YYYY-MM-DD')) {
                dateIsClosed = false;
              }
            });

            return dateIsClosed;
          }
        }));
      },

      setupDatepicker: function() {
        _this.picker = new Pikaday(_this.pickerOpts);
      }
    }
  };

  module.init();
};
